const moment = require("moment")

export const createRTS = () =>
  moment().format("dddd, MMMM Do YYYY, H:mm:ss")

export const convertToRTS = timestamp =>
  moment(timestamp).format("dddd, MMMM Do YYYY, H:mm:ss")

export const createTS = () =>
  Math.round(new Date() / 1000)



// WEBPACK FOOTER //
// ./src/utils/timestamp.js